import { useState } from "react";
import { logout } from "../../firebase/services";
import StudentHome          from "./StudentHome";
import StudentTickets       from "./StudentTickets";
import StudentNewTicket     from "./StudentNewTicket";
import StudentPayments      from "./StudentPayments";
import StudentListings      from "./StudentListings";
import StudentAnnouncements from "./StudentAnnouncements";
import Chat                 from "../../components/Chat";
import NotificationBell     from "../../components/NotificationBell";
import IamLogo              from "../../components/IamLogo";

const TABS = [
  { id: "home",          icon: "🏠", label: "Accueil"   },
  { id: "listings",      icon: "🏘️", label: "Chambres"  },
  { id: "announcements", icon: "📢", label: "Annonces"  },
  { id: "tickets",       icon: "🔧", label: "Tickets"   },
  { id: "payments",      icon: "💳", label: "Paiements" },
  { id: "chat",          icon: "💬", label: "Messages"  },
];

export default function StudentApp({ user, profile }) {
  const roomId   = profile?.roomId   || null;
  const userName = profile?.name     || "Étudiant";
  const [tab, setTab]         = useState("home");
  const [subView, setSubView] = useState(null);

  const go = (page) => {
    if (page === "newTicket")  { setSubView("newTicket"); return; }
    if (page === "payConfirm") { setTab("payments"); setSubView(null); return; }
    if (page === "listings")   { setTab("listings"); setSubView(null); return; }
    setTab(page); setSubView(null);
  };

  if (subView === "newTicket") return (
    <div style={S.shell}>
      <StudentNewTicket
        roomId={roomId}
        userId={user.uid}
        userName={userName}
        onBack={() => setSubView(null)}
        onSuccess={() => { setSubView(null); setTab("tickets"); }}
      />

    </div>
  );

  return (
    <div style={S.shell}>
      <div style={S.header}>
        <IamLogo height={28} />
        <div style={{ flex: 1 }} />
        <NotificationBell userId={user.uid} role="student" roomId={roomId} />
      </div>

      <div style={S.content}>
        {tab === "home"          && <StudentHome          roomId={roomId} onNavigate={go} />}
        {tab === "listings"      && <StudentListings      userId={user.uid} userName={userName} myRoomId={roomId} onBack={() => setTab("home")} />}
        {tab === "announcements" && <StudentAnnouncements roomId={roomId} onBack={() => setTab("home")} />}
        {tab === "tickets"       && <StudentTickets       roomId={roomId} onBack={() => setTab("home")} onNewTicket={() => setSubView("newTicket")} />}
        {tab === "payments"      && <StudentPayments      roomId={roomId} onBack={() => setTab("home")} />}
        {tab === "chat"          && <Chat roomId={roomId} currentUser={{ uid: user.uid, role: "student" }} roomLabel="IAM Business Group" onBack={() => setTab("home")} />}
      </div>

      <div style={S.nav}>
        {TABS.map(t => (
          <button key={t.id}
            style={{ ...S.navBtn, ...(tab === t.id ? S.navOn : {}) }}
            onClick={() => { setTab(t.id); setSubView(null); }}
          >
            <span style={{ fontSize: 16 }}>{t.icon}</span>
            <span style={{ fontSize: 8, marginTop: 1, fontWeight: tab === t.id ? 700 : 400 }}>{t.label}</span>
          </button>
        ))}
        <button style={S.navBtn} onClick={logout}>
          <span style={{ fontSize: 16 }}>🚪</span>
          <span style={{ fontSize: 8, marginTop: 1 }}>Quitter</span>
        </button>
      </div>
    </div>
  );
}

const S = {
  shell:   { display:"flex", flexDirection:"column", height:"100dvh", maxWidth:480, margin:"0 auto", background:"#f5f8fc" },
  header:  { background:"#1a3a5c", padding:"10px 14px", display:"flex", alignItems:"center", gap:10 },
  content: { flex:1, overflowY:"auto", display:"flex", flexDirection:"column" },
  nav:     { display:"flex", background:"white", borderTop:"0.5px solid #d0dce8", paddingBottom:"env(safe-area-inset-bottom)" },
  navBtn:  { flex:1, display:"flex", flexDirection:"column", alignItems:"center", padding:"5px 1px", background:"none", border:"none", color:"#7a90a8", cursor:"pointer", fontFamily:"inherit" },
  navOn:   { color:"#1a3a5c" },
};
